import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowUpLeftOutline = function SvgArrowUpLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54785 4.50244C4.54785 4.08823 4.88364 3.75244 5.29785 3.75244H16.5427C16.957 3.75244 17.2927 4.08823 17.2927 4.50244C17.2927 4.91665 16.957 5.25244 16.5427 5.25244H7.10851L20.3282 18.4721C20.6211 18.765 20.6211 19.2399 20.3282 19.5328C20.0353 19.8257 19.5604 19.8257 19.2675 19.5328L6.04785 6.3131V15.7473C6.04785 16.1616 5.71207 16.4973 5.29785 16.4973C4.88364 16.4973 4.54785 16.1616 4.54785 15.7473V4.50244Z"
  })));
};

export { SvgArrowUpLeftOutline as ReactComponent };
//# sourceMappingURL=arrow-up-left--outline.svg.js.map
